import { getUrlToWidget } from './get-url-to-widget';
export function getUrlToVideo(videoItem, settings) {
    const { siteUrl, compId } = settings;
    const params = {
        'wix-vod-video-id': videoItem.id,
    };
    return getUrlToWidget(siteUrl, compId, params);
}
//# sourceMappingURL=get-url-to-video.js.map